angular
  .module('contributor')

  .controller('ContributorUpdateProfileRequestsCtrl', [
    '$scope',
    '$modalInstance',
    'showSubtitle',

    function($scope, $modalInstance, showSubtitle) {
      $scope.showSubtitle = showSubtitle;

      $scope.confirm = () => {
        $modalInstance.close(
          ($scope.manualUpdateRequestCustomMessage || '').replace(/\n/g, '<br>')
        );
      };

      $scope.cancel = () => {
        $modalInstance.dismiss('cancel');
      };
    }
  ]);
